import React from 'react';
import { Grid, ResponsiveContext } from 'grommet';
import { useRepoContext } from '../contexts/RepoContext';
import { InfoCard, Spinner, UserList } from '../components';
const RepoContributors = () => {
  const {
    state: { repoDetails, loading },
  } = useRepoContext();

  return (
    <ResponsiveContext.Consumer>
      {(size) => (
        <>
          {loading ? (
            <Spinner />
          ) : (
            <Grid
              columns={{
                count: size === 'small' || size === 'xsmall' ? 1 : 2,
                size: 'auto',
              }}
              gap="small"
            >
              <InfoCard {...repoDetails} />
              <UserList users={repoDetails.contributors} />
            </Grid>
          )}
        </>
      )}
    </ResponsiveContext.Consumer>
  );
};

export { RepoContributors };
